import React, { useState } from 'react';
import { Input } from 'components/ui/input';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from 'components/ui/tooltip';
import { PROCESSOR_NAMES } from 'utils/constants';
import { isProcessorType } from 'utils/processor';
import { cn } from 'lib/utils';

interface MerchantIdInputProps {
  processorId: string;
  processorName: string;
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
}

export const MerchantIdInput: React.FC<MerchantIdInputProps> = ({
  processorId,
  processorName,
  value,
  onChange,
  disabled = false,
}) => {
  const [tooltipOpen, setTooltipOpen] = useState(false);

  const isAeropay = isProcessorType(processorName, PROCESSOR_NAMES.AEROPAY);
  const isBarterpay = isProcessorType(processorName, PROCESSOR_NAMES.BARTERPAY);

  if (!isAeropay && !isBarterpay) {
    return null;
  }

  const maxLength = isAeropay ? 15 : 36;
  const placeholder = isAeropay ? 'Merchant ID' : 'Merchant UUID';
  const tooltipText = isAeropay
    ? 'Enter Merchant ID to enable Aeropay'
    : 'Enter Merchant UUID to enable Barterpay';

  return (
    <div className="flex flex-col gap-0.5">
      <TooltipProvider>
        <Tooltip open={tooltipOpen} onOpenChange={setTooltipOpen}>
          <TooltipTrigger asChild>
            <Input
              id={`merchant-id-input-${processorId}`}
              type="text"
              maxLength={maxLength}
              placeholder={placeholder}
              value={value}
              onChange={(e) => onChange(e.target.value.trim())}
              disabled={disabled}
              className={cn(
                'h-7.5 text-sm border-2',
                value.trim() ? 'border-green-400' : 'border-gray-200'
              )}
            />
          </TooltipTrigger>
          <TooltipContent>
            <p>{tooltipText}</p>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    </div>
  );
};
